export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const CREATE_REGISTRATION_PENDING_USER = "CREATE_REGISTRATION_PENDING_USER"
export const CREATE_REGISTRATION_PENDING_USER_SUCCESS = "CREATE_REGISTRATION_PENDING_USER_SUCCESS"
export const CREATE_REGISTRATION_PENDING_USER_FAILURE = "CREATE_REGISTRATION_PENDING_USER_FAILURE"

export const GET_REGISTRATION_PENDING_USER_BY_ID = "GET_REGISTRATION_PENDING_USER_BY_ID"
export const GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS = "GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS"
export const GET_REGISTRATION_PENDING_USER_BY_ID_ERROR = "GET_REGISTRATION_PENDING_USER_BY_ID_ERROR"

export const SET_USER_TO_BE_CREATED = "set_user_to_be_created"

export const SET_CAMPAIGNS_TO_BE_CREATED = "set_campaigns_to_be_created"